module.exports = __webpack_public_path__ + "static/img/w-7.23f9739.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/worldView/w-7.jpg
// module id = jjUD
// module chunks = 1